module.exports = __webpack_public_path__ + "static/img/tuichu.ffaaff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuichu.png
// module id = jNba
// module chunks = 5